define('page/index', ['jquery', 'log', 'jquery.throttle'], ($, Log) => {
    // TODO split this chunk into smaller modules
    function switchTab(container, cb) {
        container.on('mouseenter', '.js-tab-head-list-item', function () {
            const tabBox = $(this).closest('.js-tab-box');
            const tabHead = tabBox.children('.js-tab-head');
            const tabContent = tabBox.children('.js-tab-content');
            const tabHeadSelected = $(this);
            const tabIndex = tabHeadSelected.data('tab_index');
            tabContent.children('.js-content-item').hide();
            tabHead.find('.js-tab-head-list-item').removeClass('selected');
            const contentSelected = tabContent.children(`.${tabIndex}`);
            contentSelected.show();
            tabHeadSelected.addClass('selected');
            if (typeof cb === 'function') {
                cb(tabHeadSelected, contentSelected);
            }
        });
    }
    function tabInterval() {
        const list = $('.js-finance-car .js-tab-head-list-item');
        let index = 0;
        setInterval(function () {
            index = index < list.length ? index : 0;
            list.removeClass('selected');
            $('.js-finance-car .js-content-item').hide();
            $(list[index]).addClass('selected');
            $(`.finance-lists.js-tab-index-${index}`).show();
            index++;
        }, 4000);
    }
    function initZixun(util) {
        $('.index-car-list-wrapper .js-zixun').on('click', function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
            require(['common/appoint'], (appoint) => {
                appoint.init({ car_id: $(this).data('carId') }, {
                    title: '请输入你的手机号',
                    successMessage: util.getPCIntentSuccessTips('zixun'),
                    carTitle: $(this).data('title'),
                }, 'consult');
                appoint.show();
            });
        });
    }
    // 初始化金融模块更多
    function initFinanceMore() {
        $('.js-finance-car-more').on('click', function () {
            const selected = $('.js-finance-head-list').find('.selected');
            const url = selected.data('more-url');
            window.location.href = url;
        });
    }

    // 买车模块查看更多
    function initFilterMore() {
        // 团车页面显示卖车后选项
        if (RRC.tuancheCity && RRC.tuancheCity.length && RRC.tuancheCity.indexOf(RRC.city) > -1) {
            $('.sale-choice-car-type').show();
        }
    }
    // 初始化收藏
    function initFavorite() {
        require(['page/search/mark-favorite'], favorite => favorite.init('.index-car-list-wrapper', '首页'));
    }
    // 预约
    function initAppoint(util) {
        if (util.isFromBdOther()) {
            return false;
        }
        require(['common/appoint'], (appoint) => {
            $('.js-appoint').on('click', function (e) {
                e.preventDefault();
                const ndLoggedScheduleModal = $('#js-logged-schedule-modal');
                ndLoggedScheduleModal.find('.title span').text($(this).data('title'));
                appoint.init({ car_id: $(this).data('car-id'), phone_source: $(this).data('phone-source'), token: RRC.csrftoken });
                appoint.show();
            });
        });
    }
    // 砍价
    function initBargin() {
        require(['common/bargain'], (bargain) => {
            bargain.initCarListBargain();
        });
    }
    // 对更多进行处理
    function initMoreBrands(util) {
        const $brand_more = $('#brand_more');
        const $brand_more_content = $('#brand_more_content');
        $brand_more_content.on('mouseover', 'dt', function () {
            $(this).siblings('dt').removeClass('active');
            $(this).addClass('active');
            $(this).siblings('dd').css('display', 'none');
            $(this).next('dd').css('display', 'block');
        });
        if (util.browser.iPad) {
            $brand_more.on('touchstart', (evt) => {
                $brand_more.addClass('active');
                $brand_more_content.show();
                evt.stopPropagation();
            });
            $('body').on('touchstart', () => {
                $brand_more.removeClass('active');
                $brand_more_content.hide();
            });
            $('.sub-filter a').on('click touchend', function () {
                const el = $(this);
                const link = el.attr('href');
                window.location = link;
            });
            return false;
        }
        $brand_more.mouseover(function () {
            $(this).addClass('active');
            $brand_more_content.show();
            return false;
        }).mouseout(() => {
            $brand_more_content.hide();
            $brand_more.removeClass('active');
            return false;
        });
        return true;
    }
    // 自动填充登录手机号
    function initPlaceholder() {
        if (!$.cookie('rrc_login_token')) {
            return false;
        }
        const $telephone = $.cookie('rrc_login_phone');
        $('#sell_mobile_number').attr('value', $telephone);
    }
    // banner 初始化
    function bannerInit() {
        const $navTitle = $('#common-header-wrapper .header-nav-title');
        const $cityText = $('#common-header-wrapper .choose-city');
        let timeNum = 0;

        function rollBanner(idx) {
            const $400Tel = $('#common-header-wrapper .telephone_header,.telephone_header_index');
            const $loginText = $('#common-header-wrapper .log-status');
            const $curBanner = $(`.banner-img-${idx}`);
            const bgColor = $curBanner.css('background-color');
            const bannerBox = $('.js-banner-wrapper-item');

            $('.banner-wrapper .item').css({ opacity: '0', 'z-index': '0' });
            $curBanner.css({ opacity: '1', 'z-index': '1' });
            // 改变导航字体颜色
            let [, r, g, b] = [];
            if (bgColor) {
                [, r, g, b] = bgColor.match(/\((\d+), (\d+), (\d+)/);
            }
            let textClass = 'banner-text-white';
            if (r && g && b) {
                const gray = (parseInt(r, 10) + parseInt(g, 10) + parseInt(b, 10)) / 3;
                if (gray > 128) {
                    textClass = 'banner-text-black';
                }
            }
            $navTitle.removeClass('banner-text-white');
            $400Tel.removeClass('banner-text-white');
            $loginText.removeClass('banner-text-white');
            $cityText.removeClass('banner-text-white');
            $navTitle.removeClass('banner-text-black');
            $400Tel.removeClass('banner-text-black');
            $loginText.removeClass('banner-text-black');
            $cityText.removeClass('banner-text-black');
            $navTitle.addClass(textClass);
            $400Tel.addClass(textClass);
            $loginText.addClass(textClass);
            $cityText.addClass(textClass);
            // 设置10次为了增加余量，防止第一次轮播的时候没有打出点来；
            if (timeNum < 10) {
                timeNum++;
                Log.modulePush(bannerBox.find('.js-item'));
            }
        }
        rollBanner(0);
        let index = 0;
        let banner_run = setInterval(function () {
            if (index === 5 || index === $('.banner-item-key').length) {
                index = 0;
            }
            rollBanner(index);
            index++;
        }, 3000);
        $('.banner-item-key').on('mouseenter', function () {
            clearInterval(banner_run);
            index = $(this).data('value');
            rollBanner(index);
            index++;
        });
        $('.banner-wrapper').mouseenter(function () {
            clearInterval(banner_run);
        }).mouseleave(function () {
            banner_run = setInterval(function () {
                if (index === 5 || index === $('.banner-item-key').length) {
                    index = 0;
                }
                rollBanner(index);
                index++;
            }, 3000);
        });
    }
    // 车主故事
    function sellerStory() {
        const category_owl = $('#category_owl');
        $('.category-item:eq(0)').clone().appendTo(category_owl);
        $('.category-item:eq(1)').clone().appendTo(category_owl);
        const category_item_length = category_owl.find('.category-item').length;
        category_owl.css('width', `${(category_item_length) * 400}px`);
        let now_index = 0;
        let category_timer = null;
        const items_count = (category_item_length / 2) + (category_item_length % 2);
        for (let i = 0; i < items_count - 1; i++) {
            $(`<div class="category-page" data-index="${i}" rrc-event-name="switch${ (i + 1)}"><span></span></div>`).appendTo('.category-controls'); // eslint-disable-line
        }
        const $categoryPage = $('.category-page');
        $categoryPage.eq(0).addClass('active');
        function clickJumpButton(roll_index) {
            const $that = $(this);
            category_owl.animate({
                left: `${(-400 * now_index)}px`,
            }, {
                duration: 500,
                start: () => {
                    $that.attr('disabled', 'disabled');
                },
                done: () => {
                    $that.removeAttr('disabled');
                    if (roll_index === 6) {
                        roll_index = 0; // eslint-disable-line
                    }
                    $categoryPage.eq(roll_index / 2).addClass('active').siblings().removeClass('active');
                },
            });
        }
        $('#c_next').on('click', function () {
            if (now_index >= category_item_length - 2) {
                category_owl.css('left', '-0px');
                now_index = 0;
            }
            now_index += 2;
            clickJumpButton(now_index);
        });
        $('#c_prev').on('click', function () {
            if (now_index <= 0) {
                category_owl.css('left', `${(category_item_length - 2) * (-400)}px`);
                now_index = category_item_length - 2;
            }
            now_index -= 2;
            clickJumpButton(now_index);
        });
        $categoryPage.on('click', function (e) {
            e.preventDefault();
            now_index = $(this).data('index') * 2;
            clickJumpButton(now_index);
        });
        function c_auto_play() {
            clearTimeout(category_timer);
            category_timer = setInterval(function () {
                if (now_index >= category_item_length - 2) {
                    category_owl.css('left', '-0px');
                    now_index = 0;
                }
                now_index += 2;
                clickJumpButton(now_index);
            }, 3000);
        }
        category_owl.mouseenter(function () {
            clearTimeout(category_timer);
        }).mouseleave(function () {
            c_auto_play();
        });
        $('#category_panel').mouseenter(function () {
            clearTimeout(category_timer);
        }).mouseleave(function () {
            c_auto_play();
        });
        c_auto_play();
    }
    // sem banner 初始化
    function initSemBanner() {
        let index = 0;
        function runBannerFn() {
            const $loudou = $('#loudou');
            if (index === 1) {
                $loudou.css('left', '35px').show();
            } else if (index === 2) {
                $loudou.css('left', '770px').show();
            } else {
                $loudou.hide();
            }
            $('#banner_1 img').css({ opacity: '0', 'z-index': '0' }).eq(index).css({ opacity: '1', 'z-index': '1' });
            $('#buttons div').removeClass('on').eq(index).addClass('on');
            if (index === 2) {
                index = 0;
            } else {
                index++;
            }
        }
        let banner_run = setInterval(function () {
            runBannerFn();
        }, 4000);
        const mouseLeaveFn = () => {
            banner_run = setInterval(function () {
                runBannerFn();
            }, 4000);
        };
        $('#buttons div').mouseenter(function () {
            index = $(this).data('value');
            runBannerFn();
            clearInterval(banner_run);
        }).mouseleave(mouseLeaveFn);
        $('#banner_1').mouseenter(function () {
            clearInterval(banner_run);
        }).mouseleave(mouseLeaveFn);
        $('.index-buy-sales-wrapper .index-buy-sales').mouseenter(function () {
            index = $(this).index() + 1;
            runBannerFn();
            clearInterval(banner_run);
        }).mouseleave(mouseLeaveFn);
    }
    // 新闻中心位置的初始化
    function mediaReports() {
        $('.js-media-reports-title').mouseenter(function () {
            const value = $(this).attr('data-value');
            $('.media-reports').find('ul').hide();
            $('.media-reports').find('.media-reports-title').removeClass('active');
            $(this).addClass('active');
            $(`#media-reports-${value}`).show();
        });
    }


    function initSwitchTab() {
        const orderStep = $('.js-order-step').find('.js-tab-box');
        const ournews = $('.js-ournews-part').find('.js-tab-box');
        const finance = $('.js-finance-car').find('.js-tab-box');
        const financeMore = $('.js-finance-car').find('.js-finance-car-more');
        switchTab(orderStep);
        switchTab(ournews);
        switchTab(finance, function (head) {
            const tab_index = head.data('tab_index');
            const index = tab_index.substring(tab_index.length - 1);
            const position = financeMore.attr('rrc-event-expand-tag_position');
            const newPosition = `0-${index}-more`;
            if (newPosition !== position) {
                financeMore.attr('rrc-event-expand-tag_position', newPosition);
            }
        });
        tabInterval();
    }

    function scrollForLog() {
        let isShow = false;
        const carList = $('.js-car-list-title');
        if (carList.length) {
            const firstTab = $('.js-car-list-title').find('.tab-head-lists').children('a').children('li');
            const tag_value = firstTab[0] ? firstTab.data('more_position') : '';
            $(window).on('scroll', $.throttle(200, function () {
                if (Log._isVisible(carList) && !isShow && tag_value) {
                    Log.push(['_trackEvent', 'indexpage_carrecommend_switch_tab', 'rrc-pageModule-show', '', '', { tag_value }]);
                    isShow = true;
                }
            }));
        }
    }

    // 底部浮动条和浮动标签
    function floatTag() {
        const showstr = `
            <i
                rrc-event-display="promisesellbanner_display"
                rrc-page-module
                rrc-event-expand-value="优选概念条-悬浮条"
                rrc-event-expand-page_name="首页"
            ></i>
        `;
        const hidestr = `
            <i
                rrc-event-display="promisesellbanner_display"
                rrc-page-module
                rrc-event-expand-value="优选概念条-悬浮标签"
                rrc-event-expand-page_name="首页"
            ></i>
        `;
        const floatTagStorage = window.localStorage;
        floatTagStorage.setItem('floatTag', 'hide');
        if (floatTagStorage.getItem('floatTag') === 'show') {
            $('.zhimai_float_tag').css({
                left: '0%',
            });
            $('.zhimai_float_tag .float_tag_box .tag').css({
                display: 'none'
            });
            $('#pc_zhimai_float_display').append(showstr);
        } else if (floatTagStorage.getItem('floatTag') === 'hide') {
            $('.zhimai_float_tag').css({
                left: '-100%',
            });
            $('.zhimai_float_tag .float_tag_box .tag').css({
                display: 'block'
            });
            $('.zhimai_float_tag .float_tag_box .title').css({
                display: 'none'
            });
            $('#pc_zhimai_tag_display').append(hidestr);
        }
        $('.zhimai_float_tag .float_tag_box .cancle ').click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            $('.zhimai_float_tag').animate({ left: '-100%' }, 600, function () {
                $('.zhimai_float_tag .float_tag_box .tag').css({
                    display: 'block'
                });
            });
            floatTagStorage.setItem('floatTag', 'hide');
        });

        $('.zhimai_float_tag .float_tag_box .tag>img').click(function (event) {
            event.preventDefault();
            $('.zhimai_float_tag').animate({ left: '0%' }, 600, function () {
                $('.zhimai_float_tag .float_tag_box .tag').css({
                    display: 'none'
                });
                $('.zhimai_float_tag .float_tag_box .title').css({
                    display: 'block'
                });
            });
            floatTagStorage.setItem('floatTag', 'show');
        });
    }

    function init() {
        require([
            'common/util', 'page/index/sale-car', 'widget/recommend-car-list',
        ], (util, saleCar, recommendCarList) => {
            scrollForLog();
            initFilterMore();
            initFavorite();
            initAppoint(util);
            initZixun(util);
            initBargin();
            initMoreBrands(util);
            initPlaceholder();
            bannerInit();
            sellerStory();
            initSemBanner();
            saleCar.init($('#sell_submit'));
            recommendCarList.init();
            mediaReports();
            initSwitchTab();
            initFinanceMore();
            floatTag();
        });
    }
    return {
        initFilterMore,
        initFavorite,
        initAppoint,
        initBargin,
        initMoreBrands,
        initPlaceholder,
        bannerInit,
        sellerStory,
        initSemBanner,
        init,
    };
});
/* istanbul ignore if */
if (typeof window.__karma__ === 'undefined') {
    require(['page/index'], (page) => {
        page.init();
    });
}
